import React from 'react';
import {
  companyTabBar, companyTab, companyTabActive, companyTabIdle, companyTabLabel, companyTabTag,
  companyTabStack, companyTabSub,
} from './constants';

// The name part of one company tab: the company, and under it `sub` when two
// tabs share the company (service / description — CoverageDisplay's
// engagementLabelsOf decides it). Shared with the Engagement Amendment tabs.
export const CompanyTabName = ({ label, sub }) => (sub ? (
  <span className={companyTabStack}>
    <span className={companyTabLabel}>{label}</span>
    <span className={companyTabSub}>{sub}</span>
  </span>
) : <span className={companyTabLabel}>{label}</span>);

// One tab per company — Signed Financial Statements filed several at a time
// (New page) and the Management FS record form creating several records.
// Same pill look as the Engagement Amendment tabs (tokens in constants.js).
//
// items: [{ id, label, sub?, title?, tag?: { text, tone: 'done'|'info'|'todo'|'muted', title? } }]
// `tag` is the per-tab status chip ("AI Passed", "3 Missing"…).
const CompanyTabBar = ({ items, activeId, onSelect, className = '' }) => (
  <div role="tablist" className={`${companyTabBar} ${className}`}>
    {items.map(({ id, label, sub, title, tag }) => (
      <button
        key={id}
        type="button"
        role="tab"
        aria-selected={activeId === id}
        onClick={() => onSelect(id)}
        title={title || label}
        className={`${companyTab} ${activeId === id ? companyTabActive : companyTabIdle}`}
      >
        <CompanyTabName label={label} sub={sub} />
        {tag && (
          <span className={companyTabTag[tag.tone] || companyTabTag.muted} title={tag.title || tag.text}>
            {tag.text}
          </span>
        )}
      </button>
    ))}
  </div>
);

export default CompanyTabBar;
